module.exports = __webpack_public_path__ + "static/img/so4_1.965f96c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so4_1.jpg
// module id = eX5k
// module chunks = 11